<template>
  <b-modal
      ref="modal"
      :id="element.parameter"
      hide-footer>
    <div v-for="item in element.elements" :key="item.name || item.type">
      <form v-if="item.type === 'input'" :ref="item.name" @submit.stop.prevent="handleSubmitModal">
        <b-form-group
            :label="element.caption"
            label-for="email-input"
            :invalid-feedback="email.message"
            :state="email.state"
        >
          <b-form-input
              id="email-input"
              v-model="emailValue"
              :state="email.state"
              :placeholder="item.placeholder"
              required
          ></b-form-input>
        </b-form-group>
      </form>
    </div>
    <b-button class="btn-success" variant="success" @click="handleOkModal(element.parameter)">{{ element.elements.button.name }}
    </b-button>
  </b-modal>
</template>

<script>

export default {
  name: "EmailModalLegal",
  props: {
    element: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      email: {
        state: null,
        message: ''
      },
      emailValue: '',
      reqExp: /^([A-za-z0-9_-]+\.)*[A-Za-z0-9_-]+@[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*\.[A-Za-z]{2,6}$/,
    }
  },
  mounted() {
    this.resetModal();
  },
  methods: {
    resetModal() {
      this.email.state = null
    },
    handleOkModal(type) {
      this.handleSubmitModal(type)
    },
    handleSubmitModal(type) {
      if (!this.checkFormModalValidity(type)) {
        return
      }
      this.$nextTick(() => {
        this.$bvModal.hide(type);
        this.$emit("change", this.emailValue);

      })
    },
    checkFormModalValidity(type) {
      this.emailValue = this.emailValue.trim();
      const valid = this.reqExp.test(this.emailValue) && this.$refs[type][0].checkValidity();
      this[type].state = valid;
      this[type].message = this.getEmailErrMessage();
      return valid
    },
    getEmailErrMessage() {
      const errors = this.element.elements.email_input.errors;
      return this.emailValue.length > 0 ? errors.format : errors.required
    },
  }
}
</script>

<style lang="scss">
  .modal-dialog {
    .modal-content {
      .modal-header {
        justify-content: center;
        align-items: center;
        border-bottom: none;
        padding: 1rem 0.5rem 0;
        .modal-title {
          padding-left: 1rem;
          width: 100%;
          text-align: center;
          font-weight: bold;
          font-size: 21px;
        }
        .close {
          padding: 0 1rem 2.5rem;
          margin: 0;
        }
      }
      .modal-body {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0.5rem 4.5rem 4rem;
        div {
          width: 100%;
        }
        .form-group {
          label[for="email-input"] {
            font-weight: bold;
            font-size: 18px;
            margin-bottom: 0.5rem;
          }
          input {
            display: block;
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            background-color: #fff;
            background-clip: padding-box;
            border: 1px solid #ced4da;
            border-top-color: rgb(206, 212, 218);
            border-right-color: rgb(206, 212, 218);
            border-bottom-color: rgb(206, 212, 218);
            border-left-color: rgb(206, 212, 218);
            border-radius: 0.25rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            &.is-invalid {
              border-color: #dc3545;
            }
          }
          input:focus {
            box-shadow: none;
            border-color: #00D352;
          }
          input::placeholder {
            opacity: 0.3;
          }
          input {
            &.is-invalid:focus {
              box-shadow: none;
              border-color: #dc3545;
            }
          }
          .form-control {
            border-radius: 0;
          }
        }

        .btn {

          cursor: pointer;
          box-shadow: none;
          opacity: 0.8;
          font-size: 1rem;
          font-weight: bold;
          color: #fff;
          background-color: #28a745;
          border-color: #28a745;
          min-width: 200px;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          padding: 0.375rem 0.75rem;
          line-height: 1.5;
          border-radius: 0.25rem;
          transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        .btn:hover {
          color: #fff;
          background-color: #28a745;
          border-color: #28a745;
        }
      }
    }
    .cell.selected {
      background: #00D352 !important;
    }
  }
</style>
